import React, { useState } from 'react';
import './App.css';

// レイアウト選択用の図コンポーネント
const LayoutIcon = ({ type, isSelected, onClick, label, description }) => {
  const containerStyle = {
    cursor: 'pointer',
    borderRadius: '16px',
    border: isSelected ? '3px solid #667eea' : '2px solid #e2e8f0',
    // background: isSelected ? 'rgba(102, 126, 234, 0.1)' : 'white',
    padding: '16px',
    transition: 'all 0.3s ease',
    textAlign: 'center',
    minWidth: '140px',
    transform: isSelected ? 'scale(1.05)' : 'scale(1)',
    boxShadow: isSelected ? '0 8px 25px rgba(102, 126, 234, 0.3)' : '0 2px 10px rgba(0, 0, 0, 0.1)'
  };

  const renderIcon = () => {
    const iconProps = {
      viewBox: '0 0 80 80',
      width: '60px',
      height: '60px'
    };

    switch (type) {
      case 'row':
        return (
          <svg {...iconProps}>
            <rect x="8" y="32" width="12" height="16" fill="#667eea" rx="3"/>
            <rect x="24" y="32" width="12" height="16" fill="#667eea" rx="3"/>
            <rect x="40" y="32" width="12" height="16" fill="#667eea" rx="3"/>
            <rect x="56" y="32" width="12" height="16" fill="#667eea" rx="3"/>
          </svg>
        );
      case 'twoRows':
        return (
          <svg {...iconProps}>
            {/* 上段 */}
            <rect x="16" y="16" width="12" height="14" fill="#667eea" rx="3"/>
            <rect x="32" y="16" width="12" height="14" fill="#667eea" rx="3"/>
            <rect x="48" y="16" width="12" height="14" fill="#667eea" rx="3"/>
            {/* 下段 */}
            <rect x="16" y="50" width="12" height="14" fill="#667eea" rx="3"/>
            <rect x="32" y="50" width="12" height="14" fill="#667eea" rx="3"/>
            <rect x="48" y="50" width="12" height="14" fill="#667eea" rx="3"/>
          </svg>
        );
      case 'circle':
        return (
          <svg {...iconProps}>
            <circle cx="40" cy="40" r="25" stroke="#667eea" strokeWidth="2" fill="none" strokeDasharray="3,3"/>
            <circle cx="40" cy="15" r="6" fill="#667eea"/>
            <circle cx="60" cy="25" r="6" fill="#667eea"/>
            <circle cx="65" cy="40" r="6" fill="#667eea"/>
            <circle cx="60" cy="55" r="6" fill="#667eea"/>
            <circle cx="40" cy="65" r="6" fill="#667eea"/>
            <circle cx="20" cy="55" r="6" fill="#667eea"/>
            <circle cx="15" cy="40" r="6" fill="#667eea"/>
            <circle cx="20" cy="25" r="6" fill="#667eea"/>
          </svg>
        );
      case 'square':
        return (
          <svg {...iconProps}>
            <rect x="20" y="20" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="36" y="20" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="52" y="20" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="20" y="40" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="36" y="40" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="52" y="40" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="20" y="60" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="36" y="60" width="12" height="12" fill="#667eea" rx="2"/>
            <rect x="52" y="60" width="12" height="12" fill="#667eea" rx="2"/>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      {renderIcon()}
      <div style={{ marginTop: '8px', fontSize: '14px', fontWeight: '600', color: '#4a5568' }}>
        {label}
      </div>
      <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
        {description}
      </div>
    </div>
  );
};

function App() {
  const [seatCount, setSeatCount] = useState(4);
  const [layout, setLayout] = useState('row');
  const [participants, setParticipants] = useState(Array(4).fill({ name: '', gender: 'none' }));
  const [seatAssignment, setSeatAssignment] = useState([]);
  
  // 卓設定の状態
  const [tableCount, setTableCount] = useState(1);
  const [tableSeats, setTableSeats] = useState([4]); // 各卓の座席数配列

  const layoutOptions = [
    { value: 'row', label: 'カウンター', description: '横一列' },
    { value: 'twoRows', label: 'テーブル', description: '向かい合わせ' },
    { value: 'circle', label: '円卓', description: '囲いこむ' },
    { value: 'square', label: 'お花見', description: '整列する' }
  ];


  // 卓数の変更（卓が増減する時に座席数を自動配分しない）
  const handleTableCountChange = (newCount) => {
    setTableCount(newCount);
    
    // 新しい卓の座席数配列を作成（既存の席数は維持）
    const newTableSeats = [...tableSeats];
    
    if (newCount > tableSeats.length) {
      // 卓数が増えた場合、新しい卓にデフォルト席数を設定
      const defaultSeats = Math.max(1, Math.floor(seatCount / newCount));
      while (newTableSeats.length < newCount) {
        newTableSeats.push(defaultSeats);
      }
    } else if (newCount < tableSeats.length) {
      // 卓数が減った場合、末尾の卓を削除
      newTableSeats.splice(newCount);
    }
    
    setTableSeats(newTableSeats);
  };

  // 各卓の座席数の変更
  const handleTableSeatChange = (tableIndex, newSeats) => {
    const newTableSeats = [...tableSeats];
    newTableSeats[tableIndex] = newSeats;
    setTableSeats(newTableSeats);
    
    // 総席数を更新
    const totalSeats = newTableSeats.reduce((sum, seats) => sum + seats, 0);
    setSeatCount(totalSeats);
    
    // 参加者配列を席数に合わせて調整
    const newParticipants = [...participants];
    
    if (totalSeats > participants.length) {
      // 席数が増えた場合、空のオブジェクトを追加
      while (newParticipants.length < totalSeats) {
        newParticipants.push({ name: '', gender: 'none' });
      }
    } else if (totalSeats < participants.length) {
      // 席数が減った場合、末尾から削除
      newParticipants.splice(totalSeats);
    }
    
    setParticipants(newParticipants);
  };

  // 参加者名の更新
  const updateParticipantName = (index, name) => {
    const updated = [...participants];
    updated[index] = { ...updated[index], name };
    setParticipants(updated);
  };

  // 参加者の性別の更新
  const updateParticipantGender = (index, gender) => {
    const updated = [...participants];
    updated[index] = { ...updated[index], gender };
    setParticipants(updated);
  };

  // 参加者を自動入力（A、B、C...の順番）
  const autoFillParticipants = () => {
    const updated = [...participants];
    updated.forEach((participant, index) => {
      updated[index] = { 
        ...participant, 
        name: String.fromCharCode(65 + index) // A=65, B=66, C=67...
      };
    });
    setParticipants(updated);
  };

  // 参加者を卓ごとに配分するヘルパー関数
  const distributeParticipantsToTables = (participantList, tableSeatCounts) => {
    const totalSeats = tableSeatCounts.reduce((sum, seats) => sum + seats, 0);
    let participantsForAssignment = [...participantList];
    
    // 席数が名の数より多い場合、空の名前を追加
    while (participantsForAssignment.length < totalSeats) {
      participantsForAssignment.push({ name: '', gender: 'none' });
    }
    
    // 席数が名の数より少ない場合、最初のN個を取る
    if (participantsForAssignment.length > totalSeats) {
      participantsForAssignment = participantsForAssignment.slice(0, totalSeats);
    }
    
    // Fisher-Yates shuffleアルゴリズムでシャッフル
    for (let i = participantsForAssignment.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [participantsForAssignment[i], participantsForAssignment[j]] = [participantsForAssignment[j], participantsForAssignment[i]];
    }
    
    // 参加者を卓ごとに配分
    const tableAssignments = [];
    let participantIndex = 0;
    
    tableSeatCounts.forEach((seatCount, tableIndex) => {
      const tableParticipants = participantsForAssignment.slice(participantIndex, participantIndex + seatCount);
      tableAssignments.push({
        tableNumber: tableIndex + 1,
        seatCount: seatCount,
        participants: tableParticipants
      });
      participantIndex += seatCount;
    });
    
    return tableAssignments;
  };

  const generateRandomAssignments = () => {
    const participantsWithData = participants.filter(p => p.name.trim());
    
    if (participantsWithData.length === 0) return;
    
    const tableAssignments = distributeParticipantsToTables(participantsWithData, tableSeats);
    setSeatAssignment(tableAssignments);
  };

  const generateAlternatingAssignments = () => {
    const participantsWithData = participants.filter(p => p.name.trim());
    
    if (participantsWithData.length === 0) return;
    
    // 男性、女性、未設定を分ける
    let males = participantsWithData.filter(p => p.gender === 'male');
    let females = participantsWithData.filter(p => p.gender === 'female');
    let noneGender = participantsWithData.filter(p => p.gender === 'none');
    
    // Fisher-Yates shuffleアルゴリズムで各グループをシャッフル
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };
    
    males = shuffleArray(males);
    females = shuffleArray(females);
    noneGender = shuffleArray(noneGender);
    
    // 卓ごとに男女混合で配分
    const tableAssignments = [];
    let maleIndex = 0;
    let femaleIndex = 0;
    let noneIndex = 0;
    
    for (let tableIndex = 0; tableIndex < tableSeats.length; tableIndex++) {
      const seatCount = tableSeats[tableIndex];
      const tableParticipants = [];
      let lastGender = null;
      
      // この卓の席数分、ランダムに性別を配置（連続を避ける）
      
      for (let i = 0; i < seatCount; i++) {
        // 利用可能な性別を取得
        const availableGenders = [];
        if (maleIndex < males.length) availableGenders.push('male');
        if (femaleIndex < females.length) availableGenders.push('female');
        if (noneIndex < noneGender.length) availableGenders.push('none');
        
        // 前回と同じ性別を避ける
        let nextGenders = [];
        for (let j = 0; j < availableGenders.length; j++) {
          if (availableGenders[j] !== lastGender) {
            nextGenders.push(availableGenders[j]);
          }
        }
        const selectedGender = nextGenders.length > 0 
          ? nextGenders[Math.floor(Math.random() * nextGenders.length)]
          : availableGenders[Math.floor(Math.random() * availableGenders.length)];
        
        // 選択された性別の参加者を追加
        if (selectedGender === 'male') {
          tableParticipants.push(males[maleIndex]);
          maleIndex++;
        } else if (selectedGender === 'female') {
          tableParticipants.push(females[femaleIndex]);
          femaleIndex++;
        } else if (selectedGender === 'none') {
          tableParticipants.push(noneGender[noneIndex]);
          noneIndex++;
        } else {
          // 全て足りない場合は空の名前
          tableParticipants.push({ name: '', gender: 'none' });
        }
        
        lastGender = selectedGender;
      }
      
      tableAssignments.push({
        tableNumber: tableIndex + 1,
        seatCount: seatCount,
        participants: tableParticipants
      });
    }
    
    setSeatAssignment(tableAssignments);
  };


  const renderSeats = () => {
    if (seatAssignment.length === 0) return null;

    const renderCircleSeatsForTable = (participants, tableNumber) => {
      const centerX = 175; // 円の中心X（350px ÷ 2）
      const centerY = 175; // 円の中心Y（350px ÷ 2）
      const radius = 110; // 円の半径（席が円の境界線の中で収まるように調整）
      
      return (
        <div className="circle-for-table-container">
          {participants.map((participant, index) => {
            const angle = (2 * Math.PI * index) / participants.length - Math.PI / 2; // 上から開始
            const x = centerX + radius * Math.cos(angle);
            const y = centerY + radius * Math.sin(angle);
            
            const genderClass = participant.gender === 'male' ? 'male-seat' : 
                               participant.gender === 'female' ? 'female-seat' : 'empty-seat';
            
            return (
              <div 
                key={index} 
                className={`seat circle-seat ${genderClass}`}
                style={{
                  position: 'absolute',
                  left: `${x}px`,
                  top: `${y}px`,
                  transform: 'translate(-50%, -50%)'
                }}
              >
                {/* <span className="seat-number">{index + 1}</span> */}
                <span className="seat-name">{participant.name}</span>
              </div>
            );
          })}
          
          {/* 中央の卓タイトル */}
          <div 
            className="circle-table-title-center"
            style={{
              position: 'absolute',
              left: `${centerX}px`,
              top: `${centerY}px`,
              transform: 'translate(-50%, -50%)'
            }}
          >
            <span className="circle-table-number">卓{tableNumber}</span>
          </div>
        </div>
      );
    };

    const renderTwoRowSeatsForTable = (participants, tableNumber) => {
      const half = Math.ceil(participants.length / 2);
      const firstRow = participants.slice(0, half);
      const secondRow = participants.slice(half);
      
      return (
        <div className="two-rows-for-table-container">
          <div className="row-group">
            {firstRow.map((participant, index) => {
              const genderClass = participant.gender === 'male' ? 'male-seat' : 
                                 participant.gender === 'female' ? 'female-seat' : 'empty-seat';
              return (
                <div key={index} className={`seat ${genderClass}`}>
                  {/* <span className="seat-number">{index + 1}</span> */}
                  <span className="seat-name">{participant.name}</span>
                </div>
              );
            })}
          </div>
          
          {/* 中央の卓タイトル */}
          <div className="table-title-center">
            <span className="table-number-center">卓{tableNumber}</span>
          </div>
          
          <div className="row-group">
            {secondRow.map((participant, index) => {
              const genderClass = participant.gender === 'male' ? 'male-seat' : 
                                 participant.gender === 'female' ? 'female-seat' : 'empty-seat';
              return (
                <div key={index + half} className={`seat ${genderClass}`}>
                  {/* <span className="seat-number">{index + half + 1}</span> */}
                  <span className="seat-name">{participant.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      );
    };


    const renderRegularSeats = (participants) => {
      return participants.map((participant, index) => {
        const genderClass = participant.gender === 'male' ? 'male-seat' : 
                           participant.gender === 'female' ? 'female-seat' : 'empty-seat';
        return (
          <div key={index} className={`seat ${genderClass}`}>
            {/* <span className="seat-number">{index + 1}</span> */}
            <span className="seat-name">{participant.name}</span>
          </div>
        );
      });
    };

    const renderSquareSeatsForTable = (participants) => {
      const seatCount = participants.length;
      
      // 正方形状にするために列数を計算
      const columns = Math.ceil(Math.sqrt(seatCount));

      return (
        <div className="square-grid" style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: '15px',
          width: '100%',
          maxWidth: 'none'
        }}>
          {participants.map((participant, index) => {
            const genderClass = participant.gender === 'male' ? 'male-seat' : 
                               participant.gender === 'female' ? 'female-seat' : 'empty-seat';
            return (
              <div key={index} className={`seat ${genderClass}`}>
                <span className="seat-name">{participant.name}</span>
              </div>
            );
          })}
        </div>
      );
    };

    return (
      <div className="tables-container">
        {seatAssignment.map((table, tableIndex) => (
          <div key={tableIndex} className={`table-section ${layout === 'twoRows' || layout === 'circle' ? 'special-table-section' : ''}`}>
            {layout !== 'twoRows' && layout !== 'circle' && layout !== 'square' && <h3 className="table-title">卓{table.tableNumber}</h3>}
            <div className={`seat-container ${layout}`}>
              {layout === 'circle' && renderCircleSeatsForTable(table.participants, table.tableNumber)}
              {layout === 'twoRows' && renderTwoRowSeatsForTable(table.participants, table.tableNumber)}
              {layout === 'row' && renderRegularSeats(table.participants)}
              {layout === 'square' && renderSquareSeatsForTable(table.participants)}
            </div>
          </div>
        ))}
        
      </div>
    );
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>席決めちゃん</h1>
        
        <div className="input-section">
          <div className="input-group">
            <label>卓の設定:</label>
            <div className="table-settings">
              <div className="table-setting-item">
                <label htmlFor="tableCount">卓数:</label>
                <input
                  id="tableCount"
                  type="number"
                  min="1"
                  max="10"
                  value={tableCount}
                  onChange={(e) => {
                    const newCount = parseInt(e.target.value) || 1;
                    handleTableCountChange(newCount);
                  }}
                />
                <div>卓</div>
              </div>
              
              <div className="individual-table-settings">
                {tableSeats.map((seats, index) => (
                  <div key={index} className="table-setting-item">
                    <label>卓{index + 1}:</label>
                    <input
                      type="number"
                      min="1"
                      max="20"
                      value={seats}
                      onChange={(e) => {
                        const newSeats = parseInt(e.target.value) || 1;
                        handleTableSeatChange(index, newSeats);
                      }}
                    />
                    <span>席</span>
                  </div>
                ))}
              </div>
              
              <div className="table-info">
                総席数: {tableSeats.reduce((sum, seats) => sum + seats, 0)}席
              </div>
            </div>
          </div>

          <div className="input-group">
            <label>席の種類:</label>
            <div className="layout-selection">
              {layoutOptions.map(option => (
                <LayoutIcon
                  key={option.value}
                  type={option.value}
                  isSelected={layout === option.value}
                  onClick={() => setLayout(option.value)}
                  label={option.label}
                  description={option.description}
                />
              ))}
            </div>
          </div>

          <div className="input-group">
            <label>参加者名:</label>
            <div className="participants-header">
              <button 
                className="auto-fill-button"
                onClick={autoFillParticipants}
              >
                Aから自動入力
              </button>
            </div>
            <div className="participants-container">
              {participants.map((participant, index) => (
                <div key={index} className="participant-input">
                  <input
                    type="text"
                    value={participant.name}
                    onChange={(e) => updateParticipantName(index, e.target.value)}
                  />
                  <select
                    value={participant.gender}
                    onChange={(e) => updateParticipantGender(index, e.target.value)}
                    className="gender-select"
                  >
                    <option value="none">-</option>
                    <option value="male">男性</option>
                    <option value="female">女性</option>
                  </select>
                </div>
              ))}
            </div>
          </div>

          <div className="button-group">
            <button 
              className="generate-button"
              onClick={generateRandomAssignments}
              disabled={participants.filter(p => p.name.trim()).length === 0}
            >
              ランダムに席を決める
            </button>
            
            <button 
              className="generate-button alternating-button"
              onClick={generateAlternatingAssignments}
              disabled={participants.filter(p => p.name.trim() && p.gender !== 'none').length === 0}
            >
              男女交互に席を決める
            </button>
          </div>
        </div>

        {renderSeats()}
      </header>
    </div>
  );
}

export default App;
